module.exports = new __parcel__URL__("Charlie_Display-Light.3e8a654a.woff2").toString();